"use client";

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from "@headlessui/react";
import type { ReactNode } from "react";
import { Fragment } from "react";
import useHasTouchInput from "@/hooks/useHasTouchInput";
export default function CommonDropdownItemsMobileWrapper(t0) {
  const $ = _c(29);
  const {
    isOpen,
    setOpen,
    label,
    hideOnDesktopHover: t1,
    zIndexClassName: t2,
    onAfterLeave,
    children
  } = t0;
  const hideOnDesktopHover = t1 === undefined ? true : t1;
  const zIndexClassName = t2 === undefined ? "tw-z-[1000]" : t2;
  const hasTouchInput = useHasTouchInput();
  const shouldHideOnDesktopHover = hideOnDesktopHover && !hasTouchInput;
  const t3 = `tailwind-scope tw-absolute ${zIndexClassName} ${shouldHideOnDesktopHover ? "lg:desktop-hover:tw-hidden" : ""}`;
  let t4;
  if ($[0] !== onAfterLeave) {
    t4 = onAfterLeave ? {
      afterLeave: onAfterLeave
    } : {};
    $[0] = onAfterLeave;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="tw-fixed tw-inset-0 tw-bg-iron-600/60 tw-transition-opacity" />;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t4) {
    t6 = <TransitionChild as={Fragment} enter="tw-duration-300 tw-ease-in-out" enterFrom="tw-opacity-0" enterTo="tw-opacity-100" leave="tw-duration-300 tw-ease-in-out" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-0" {...t4}>{t5}</TransitionChild>;
    $[3] = t4;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== setOpen) {
    t7 = () => setOpen(false);
    $[5] = setOpen;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <svg className="tw-h-6 tw-w-6 tw-flex-shrink-0 tw-text-white" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t7) {
    t9 = <TransitionChild as={Fragment} enter="tw-duration-300 tw-ease-in-out" enterFrom="tw-opacity-0" enterTo="tw-opacity-100" leave="tw-duration-300 tw-ease-in-out" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-0"><div className="tw-absolute -tw-top-16 tw-right-0 -tw-ml-8 tw-flex tw-pr-2 tw-pt-4 sm:-tw-ml-10 sm:tw-pr-4"><button type="button" title="Close panel" aria-label="Close panel" className="tw-relative tw-rounded-md tw-border-none tw-bg-transparent tw-p-2.5 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-white" onClick={t7}>{t8}</button></div></TransitionChild>;
    $[8] = t7;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      maxHeight: "calc(100vh - 8rem)",
      paddingBottom: "env(safe-area-inset-bottom,0px)"
    };
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== label) {
    t11 = label && <div className="tw-px-6"><DialogTitle className="tw-text-base tw-font-semibold tw-text-iron-50">{label}</DialogTitle></div>;
    $[11] = label;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== children) {
    t12 = <div className="tw-relative tw-mt-3 tw-flex tw-flex-1 tw-flex-col tw-gap-y-6 tw-px-4 sm:tw-px-6"><ul className="tw-mx-0 tw-mb-0 tw-flex tw-list-none tw-flex-col tw-space-y-3 tw-pl-0">{children}</ul></div>;
    $[13] = children;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t11 || $[16] !== t12) {
    t13 = <div className="tw-flex tw-scroll-py-3 tw-flex-col tw-overflow-y-auto tw-rounded-t-xl tw-bg-iron-950 tw-pt-4" style={t10}>{t11}{t12}</div>;
    $[15] = t11;
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t13 || $[19] !== t9) {
    t14 = <div className="tw-fixed tw-inset-0 tw-overflow-hidden"><div className="tw-absolute tw-inset-0 tw-overflow-hidden"><div className="tw-pointer-events-none tw-fixed tw-inset-x-0 tw-bottom-0 tw-flex tw-max-w-full tw-pt-10"><TransitionChild as={Fragment} enter="tw-transform tw-transition tw-duration-300 tw-ease-out" enterFrom="tw-translate-y-full" enterTo="tw-translate-y-0" leave="tw-transform tw-transition tw-duration-300 tw-ease-in" leaveFrom="tw-translate-y-0" leaveTo="tw-translate-y-full"><DialogPanel className="tw-pointer-events-auto tw-relative tw-w-screen tw-transform-gpu">{t9}{t13}</DialogPanel></TransitionChild></div></div></div>;
    $[18] = t13;
    $[19] = t9;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== setOpen || $[22] !== t14 || $[23] !== t3 || $[24] !== t6) {
    t15 = <Dialog as="div" className={t3} onClose={setOpen}>{t6}{t14}</Dialog>;
    $[21] = setOpen;
    $[22] = t14;
    $[23] = t3;
    $[24] = t6;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== isOpen || $[27] !== t15) {
    t16 = <Transition show={isOpen} as={Fragment}>{t15}</Transition>;
    $[26] = isOpen;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  return t16;
}